export const ROLES = ["user", "support", "editor", "admin"] as const;
export type Role = (typeof ROLES)[number];

export const PERMISSIONS = [
  "dashboard.view",
  "catalog.read",
  "catalog.write",
  "catalog.publish",
  "media.write",
  "feedback.read",
  "feedback.write",
  "analytics.read",
  "users.read",
  "users.write",
  "settings.read",
  "settings.write",
  "audit.read",
] as const;
export type Permission = (typeof PERMISSIONS)[number];

const ROLE_PERMISSIONS: Record<Role, readonly Permission[]> = {
  user: [],
  support: ["dashboard.view", "catalog.read", "feedback.read", "feedback.write", "analytics.read"],
  editor: [
    "dashboard.view",
    "catalog.read",
    "catalog.write",
    "catalog.publish",
    "media.write",
    "feedback.read",
    "analytics.read",
  ],
  admin: PERMISSIONS,
};

export function isRole(value: unknown): value is Role {
  return typeof value === "string" && (ROLES as readonly string[]).includes(value);
}

export function permissionsFor(role: string | null | undefined): readonly Permission[] {
  return isRole(role) ? ROLE_PERMISSIONS[role] : [];
}

export function hasPermission(role: string | null | undefined, permission: Permission): boolean {
  return permissionsFor(role).includes(permission);
}

export function isStaffRole(role: string | null | undefined): boolean {
  return isRole(role) && role !== "user";
}
